import nucleus from '../assets/nucleus/nucleus.png';
import coming from '../assets/coming-soon.jpg';
import chickendinner from '../assets/chickendinner/chickendinner.png';
import chickendinnercover from '../assets/chickendinner/chickendinnercover.png';
import chickendinnercompare from '../assets/chickendinner/chickendinnercompare.png';
import chickendinnersearch from '../assets/chickendinner/chickendinnersearch.png';
import nucleus1 from '../assets/nucleus/nucleus1.png';
import nucleus2 from '../assets/nucleus/nucleus2.png';
import coordiLogin from '../assets/coordi/login.png';
import coordiLoginMobile from '../assets/coordi/loginMobile.png';
import coordiPollLight from '../assets/coordi/pollLight.png';
import coordiPollDark from '../assets/coordi/pollDark.png';
import coordiPollMobileDark from '../assets/coordi/pollMobileDark.png';
import coordiPollMobileLight from '../assets/coordi/pollMobileLight.png';

export const projects = [
  {
    category: 'SYSTEM ARCHITECTURE | FULL STACK',
    grade: 'V6',
    title: 'Chicken Dinner',
    description: 'A high-performance PUBG match and performance analysis tool built with Java and React. Currently under user testing.',
    longDescription: `The app lets players look up any PUBG account by name and instantly view comprehensive performance statistics broken down by season, game mode (Solo, Duo, Squad), and perspective (TPP/FPP). It tracks 11 calculated metrics per mode — including a custom Win Contribution Score that weights a player's revives, assists, kills, and damage into a single team-value index — alongside K/D ratio, average damage, headshot rate, win rate, top 10 rate, and movement distance. A player comparison mode lets users pit two accounts side by side with automatic winner highlighting on each stat.`,
    stack: 'Java, Spring, React, Typescript, Electron',
    color: '#3a3a38',
    image: chickendinnercover,
    screenshots: [chickendinner, chickendinnersearch, chickendinnercompare]
  },
  {
    category: 'FULL STACK',
    grade: 'V5',
    title: 'Nucleus',
    description: 'End-to-end event management platform for organizing climbing events built with React and typescript',
    stack: 'React, TypeScript, Node.js',
    longDescription: 'Nucleus is a full-stack event management platform built specifically for organizing climbing events and competitions. It features a comprehensive suite of tools including event creation, participant registration, schedule management, and real-time scoring. Built with React and TypeScript for the frontend with a modern backend architecture, Nucleus streamlines the entire process of managing climbing competitions from registration through results.',
    color: '#4a4540',
    image: nucleus,
    screenshots: [nucleus1, nucleus2]
  },
  {
    category: 'FULL STACK',
    grade: 'V5',
    title: 'Coordi',
    description: 'End-to-end poll automation platform to solve manual poll creation and coordination problems for Kakaotalk users built with React and typescript',
    stack: 'React, TypeScript, Firebase Firestore DB',
    longDescription: 'Coordi strives to resolve the problem Kakaotalk (a Korean messaging platform) users face when trying to coordinate group events. The app integrates a smooth user experience with built in KakaoTalk login and a automated poll creation on a weekly basis that keeps users engaged with location suggestions and voting features to show participation on any given day. This webapp also features archive of previous weeks of polls, customization of user profiles, weather data on any given day (based on the location of the event), and user leaderboards to encourage participation. Coordi puts mobile-first design at the forefront of its development along with dark mode, ensuring a seamless experience for users on the go with 40 active users and growing.',
    color: '#4a4540',
    image: coordiPollLight,
    screenshotSets: [
      { label: 'Desktop', screenshots: [coordiLogin, coordiPollLight, coordiPollDark] },
      { label: 'Mobile', screenshots: [coordiLoginMobile, coordiPollMobileLight, coordiPollMobileDark] },
    ],
  },
  {
    category: 'BACKEND',
    grade: 'V2',
    title: 'KSA Bot',
    description: 'Python powered Discord bot for the UMD KSA Discordcommunity, providing various utilities and moderation tools.',
    stack: 'Python',
    longDescription: 'KSA Bot is a Discord bot developed for the University of Maryland Korean Student Association community. Built entirely in Python, it provides moderation tools, event management features, and community engagement utilities. The bot handles member verification, role management, event announcements, and interactive features that enhance community engagement.',
    color: '#383838',
    image: coming
  },
];
